import { Grid } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'

import Button from './Button'
import { useGetImpostazioniAvanzateQuery } from '../hooks/api-slice'
import { colours } from '../settings/settings'

const AVANZ_FIELDS = ['LinksHomepage']

const GeneralDocs = () => {
  const { data: avanzate } = useGetImpostazioniAvanzateQuery(AVANZ_FIELDS)
  const { LinksHomepage } = avanzate || {}

  const MyButton = ({ text, toNewTab }) => (
    <Button
      transparent
      borderColor={colours.greyLight}
      toNewTab={toNewTab}
      endIcon={<OpenInNewIcon />}
    >
      {text}
    </Button>
  )

  if (!LinksHomepage?.length) return null

  return (
    <Grid
      container
      paddingTop={3}
      rowSpacing={1}
      columnSpacing={2}
      justifyContent='space-around'
      sx={{ width: '100%' }}
    >
      {LinksHomepage?.map((link, index) => (
        <MyButton key={index} text={link?.titolo} toNewTab={link?.url} />
      ))}
    </Grid>
  )
}

export default GeneralDocs
